<script>
  import math from '../functions-common/math';
  import {fade} from 'svelte/transition'
  import {createEventDispatcher} from 'svelte';

  const dispatch = createEventDispatcher();

  export let score;
  export let single = true;
  export let withDetails = false;
  export let live = false;
  export let opened = false;
  export let accType = 'total';
</script>

{#if score}
  <section class="player" on:click={() => dispatch('show-details', score)} transition:fade>
    <span class="rank">{score.rank ? `#${score.rank}` : '-'}</span>

    <span class="player-name" class:pulse={live}>
        {#if score.player_avatar_url}
          <img class="nes-avatar is-rounded is-small" alt=""
               src={score.player_avatar_url}
               style="image-rendering: pixelated;"
          />
        {/if}

      <span>{score.player_name}</span>
    </span>

    {#if !single}
      <span class="progress tablet-and-up-only">
        <progress class={`nes-progress ${score.progressClass}`} title="{score.maps_passed}/{score.maps_cnt}"
                  value={score.maps_passed_percent} max="100"
        ></progress>
      </span>
    {/if}

    <span class="acc"
          title={!single && score.avg_passed_acc ? `Passed maps average accuracy: ${math.formatNumber(score.avg_passed_acc)}%` : ''}
    >
      {#if accType === 'total'}
        {score.acc ? `${math.formatNumber(score.acc)}%` : '-'}
      {:else}
        {score.avg_passed_acc ? `${math.formatNumber(score.avg_passed_acc)}%` : '-'}
      {/if}
    </span>

    <span class="score tablet-and-up-only">{score.score ? math.formatNumber(score.score, 0) : '-'}</span>

    {#if withDetails}
      <span class="more" title="Show/hide scores">
        <span class="chevron">
          <img src={"/assets/images/" + (opened ? 'chevron-down' : 'chevron-right') + ".png"}/>
        </span>
      </span>
    {/if}
  </section>
{/if}

<style>
    .player {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: .5rem;
        cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAzElEQVRYR+2X0Q6AIAhF5f8/2jYXZkwEjNSVvVUjDpcrGgT7FUkI2D9xRfQETwNIiWO85wfINfQUEyxBG2ArsLwC0jioGt5zFcwF4OYDPi/mBYKm4t0U8ATgRm3ThFoAqkhNgWkA0jJLvaOVSs7j3qMnSgXWBMiWPXe94QqMBMBc1VZIvaTu5u5pQewq0EqNZvIEMCmxAawK0DNkay9QmfFNAJUXfgGgUkLaE7j/h8fnASkxHTz0DGIBMCnBeeM7AArpUd3mz2x3C7wADglA8BcWMZhZAAAAAElFTkSuQmCC) 14 0, pointer;
    }

    .player > .progress :global(.nes-progress) {
        height: 1rem;
        width: clamp(5rem, 8rem, 10rem) !important;
        margin-right: .5rem;
    }

    .player > * {
        width: max-content;
        margin-right: 1rem;
    }

    .player > *:last-child {
        margin-right: 0;
    }

    .player .player-name {
        display: inline-flex;
        align-items: center;
        justify-content: flex-start;
    }

    .player .player-name img {
        margin-right: .5rem;
    }

    .rank {
        width: 2rem !important;
    }

    .player-name {
        flex-grow: 1;
        width: auto;
        text-decoration: none;
    }

    .progress {
        display: inline-flex;
        align-items: center;
    }

    .fc {
        width: 1.5rem!important;
        text-align: right;
    }

    .acc {
        width: 4.5rem !important;
        text-align: right;
    }

    .score {
        width: 8rem !important;
        text-align: right;
    }

    .more {
        position: relative;
        top: -2px;
        width: 1.25rem !important;
        height: 1.25rem;
        cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAzElEQVRYR+2X0Q6AIAhF5f8/2jYXZkwEjNSVvVUjDpcrGgT7FUkI2D9xRfQETwNIiWO85wfINfQUEyxBG2ArsLwC0jioGt5zFcwF4OYDPi/mBYKm4t0U8ATgRm3ThFoAqkhNgWkA0jJLvaOVSs7j3qMnSgXWBMiWPXe94QqMBMBc1VZIvaTu5u5pQewq0EqNZvIEMCmxAawK0DNkay9QmfFNAJUXfgGgUkLaE7j/h8fnASkxHTz0DGIBMCnBeeM7AArpUd3mz2x3C7wADglA8BcWMZhZAAAAAElFTkSuQmCC) 14 0, pointer;
    }

    .chevron{
        position: relative;
        width: 14px;
        height: 14px;
    }
</style>